<div :class="{'is-page': isPage}">
    <editor :id="id" ref="editor" :api-key="key" :init="selectedOptions" :disabled="disabled" :value="value" @input="handleInput"/>
</div>